import React from 'react';

import './Form.module.css';

const CheckBox = ({ children, ...props }) => {
  return (
    <label styleName="container">
      {children}
      <input type="checkbox" {...props} />
      <span styleName="checkmark" />
    </label>
  );
};

export default CheckBox;
